import { Component, inject, Input, TemplateRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-basic',
  templateUrl: './modal-basic.component.html',
  styleUrls: ['./modal-basic.component.css'],
})
export class ModalBasicComponent {
  activeModal = inject(NgbActiveModal);
  @Input() title: string = '';
  content!: string | TemplateRef<any>;
  @Input() buttons: {
    text: string;
    color?: string;
    action?: () => void;
    minWidth?: string;
  }[] = [];
  @Input() showCloseButton: boolean = true;

  /**
   * NgbModal suele asignar `content` vía `componentInstance` después de `open()`.
   * Si se calculaba solo en ngOnInit, `content` aún era undefined y el cuerpo quedaba vacío.
   */
  get isTextContent(): boolean {
    return typeof this.content === 'string';
  }

  get templateContent(): TemplateRef<any> | null {
    return this.isTextContent ? null : (this.content as TemplateRef<any>);
  }

  handleAction(btn: any) {
    if (btn.callback) {
      btn.callback();
      return;
    }

    if (btn.action === 'close') {
      this.activeModal.close(btn.value);
    } else if (btn.action === 'dismiss') {
      this.activeModal.dismiss(btn.value);
    } else {
      this.activeModal.close(btn.value);
    }
  }
}
